import { render, staticRenderFns } from "./RecordDateNavigation.vue?vue&type=template&id=1fc8aa86"
import script from "./RecordDateNavigation.vue?vue&type=script&lang=js"
export * from "./RecordDateNavigation.vue?vue&type=script&lang=js"
import style0 from "./RecordDateNavigation.vue?vue&type=style&index=0&id=1fc8aa86&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
